import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
export default function Footer() {
    const { t } = useTranslation();
    return (
        <footer className="flex flex-col gap-[10px] border-t-[1px] border-t-black">
            <div className="f-col p-[35px] container flex justify-between gap-[40px]">
                <div className="w-100 w-[50%] flex flex-col gap-[40px]">
                    <div className="flex flex-col gap-[8px]">
                        <Link to={"/"}>
                            <img className="w-[150px]" src={require("../../assets/logo/logo.svg").default} alt="" />
                        </Link>
                        <p className="text-[15px] text-[#5D5A6F]">
                            {t("footer text")}
                        </p>
                    </div>
                    <div className="flex flex-col gap-[8px]">
                        <div className="text-[#5D5A6F]">{t("Follow Us:")}</div>
                        <div className="flex items-center gap-[8px]">
                            <Link to={""}>
                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/facebook.svg").default} alt="" />
                            </Link>
                            <Link to={""}>
                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/instagram.svg").default} alt="" />
                            </Link>
                            <Link to={""}>
                                <img className="w-[25px] h-[25px]" src={require("../../assets/icons/whatsapp.svg").default} alt="" />
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="f-col w-100 w-[50%] flex gap-[40px] justify-end">
                    <div className="flex flex-col gap-[12px]">
                        <div className="text-[20px] font-bold">{t("Quick links")}</div>
                        <ul className="flex flex-col gap-[10px]">
                            <li>
                                <Link className="text-[#5D5A6F] text-[16px]" to={""}>{t("Home")}</Link>
                            </li>
                            <li>
                                <Link className="text-[#5D5A6F] text-[16px]" to={""}>{t("About us")}</Link>
                            </li>
                            <li>
                                <Link className="text-[#5D5A6F] text-[16px]" to={""}>{t("Services")}</Link>
                            </li>
                            <li>
                                <Link className="text-[#5D5A6F] text-[16px]" to={""}>{t("Teachers")}</Link>
                            </li>
                            <li>
                                <Link className="text-[#5D5A6F] text-[16px]" to={""}>{t("Educational Level")}</Link>
                            </li>
                            <li>
                                <Link className="text-[#5D5A6F] text-[16px]" to={""}>{t("Contact us")}</Link>
                            </li>
                        </ul>
                    </div>
                    <div className="flex flex-col gap-[12px]">
                        <div className="text-[20px] font-bold">{t("Legal")}</div>
                        <ul className="flex flex-col gap-[10px]">
                            <li>
                                <Link className="text-[#5D5A6F] text-[16px]" to={""}>{t("Privacy Policy")}</Link>
                            </li>
                            <li>
                                <Link className="text-[#5D5A6F] text-[16px]" to={""}>{t("Terms And Conditions")}</Link>
                            </li>
                            <li>
                                <Link className="text-[#5D5A6F] text-[16px]" to={""}>{t("Faqs")}</Link>
                            </li>
                        </ul>
                    </div>
                    <div className="flex flex-col gap-[12px]">
                        <div className="text-[20px] font-bold">{t("Get in touch")}</div>
                        <ul className="flex flex-col gap-[10px]">
                            <li>
                                <Link to={"tel:+962 7 9550 5652"} className="flex items-center gap-[6px]">
                                    <img className="w-[20px] h-[20px]" src={require("../../assets/icons/phone-footer.svg").default} alt="" />
                                    <span className="dir-ar">+962 7 9550 5652</span>
                                </Link>
                            </li>
                            <li>
                                <Link to={"mailto:info@be-academix.com"} className="flex items-center gap-[6px]">
                                    <img className="w-[20px] h-[20px]" src={require("../../assets/icons/email-footer.svg").default} alt="" />
                                    <span>info@be-academix.com</span>
                                </Link>
                            </li>
                            <li>
                                <Link to={""} className="flex items-center gap-[6px]">
                                    <img className="w-[20px] h-[20px]" src={require("../../assets/icons/location-footer.svg").default} alt="" />
                                    <span>{t("Amman - Jordan")}</span>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="bg-[#A31D1C] py-[10px] text-white text-center font-bold">{t("© 2025 Be Academix All rights reserved.")}</div>
        </footer>
    );
}